<template>
    
    
   <div class="
    
      border-1 
      rounded-md
      shadow-xl
      
    ">
    <div class="lg:col-span-3 bg-white ">
        <div class="md:p-2 bg-white align-middle">
            <!--  <h1 class="text-6xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-green-300 h-auto"> -->
            <h1 class="text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-br from-blue-400 to-purple-600 " style="font-size: 50px">
              Fruit Crusher

            </h1>
        </div>
    </div>
</div>

    <div class="grid grid-cols-3 bg-white"> 
        <div> 
            <img src="https://alphatech-equip.com/static/img/products/fruit_crusher.jpg"> 
            </div> 
            <div class="col-span-2 text-left pl-10 mt-10"> 

    <ul> 
        <li> 
            Fruit crusher along with loading hopper, completely in S.S. 304 </li> <li> 
Crushing blades 90 deg. Each. </li> <li> 
Available in various capacity </li> <li> 
Electrical connection: - 3 phase </li> <li> 
Mounting on stand with height match to pump hopper </li> <li> 
Suitable for grape berries, kiwi, apple, pine apple, plum etc. </li> <li> 
Grapes will be manual destemming</li> 






 </ul> 

 </div> 

 </div> 




</template>
